import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Input, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import { openNotice } from 'Utils';
import { getPro } from '../../service/thingsOrder';
import '../thingsOrder/corder.css';

class SecondCusOrderAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['订单创建'],
            key: 0,
            visible: false,
            alreadyRows: [],
            alreadyTotal: 1,
            selectedRowKeys: [],
            selectedRowKeysOutside: [],
            name: '',
            code: '',
            alreadySearchObj: {
                s: 10,
                p: 1
            },
            submitRows: [],
            add: {
                id: 1,
            },
            rows: [],
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            }
        };
    };
	/*返回*/
    goBack() {
        hashHistory.goBack();
    };
	/*选择订单商品列表*/
    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeysOutside: selectedRowKeys });
        // console.dir(selectedRows);
    };
	/*订单商品列表翻页*/
    pageChange = (page, pageSize) => {
        this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
            this.initData();
        });
    };

	/*选择物料弹窗*/
    searchHandler = (event) => {
        this.setState({visible: true});
        // this.getAlreadyArray();
    };
	/*选择物料列表*/
    onSelectChange = (selectedRowKeys, selectedRows) => {
        // console.log(selectedRowKeys);
        this.setState({
            selectedRowKeys: selectedRowKeys,
            add: {
                ...this.state.add,
                code: selectedRows[0].code,
                name: selectedRows[0].name,
            }
        })
    };
	/*选择物料列表翻页*/
    alreadyPageChange = (page, pageSize) => {
        this.setState({ alreadySearchObj: { ...this.state.alreadySearchObj, s: pageSize, p: page } }, function () {
            this.getAlreadyArray();
        });
    };
	/*选择物料-物料编码搜索*/
    codeChange = (event) => {
        this.setState({
            code: event.target.value
        });
    };
	/*选择物料-物料名称搜索*/
    nameChange = (event) => {
        this.setState({
            name: event.target.value
        });
    };
	/*选择物料列表数据(点击搜索)*/
    getAlreadyArray = () => {
        getPro({
            code: this.state.code,
            name: this.state.name,
            p: this.state.alreadySearchObj.p,
            s: this.state.alreadySearchObj.s
        }).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    alreadyRows: result.data,
                    alreadyTotal: result.total
                });
            } else {
                message.error(result.message);
            }
        })
    };
	/*点击确定保存*/
    addSaveHandler = () => {
        this.setState({visible: false});
    };
    doSave = () => {
        // this.state.add.id = window.myTemp++;
        // this.setState({submitRows: [...this.state.submitRows, this.state.add]});
        // this.setState({visible: false});
    };

	/*获取列表数据*/
    initData () {
    }
    //离开当前路由时，更新store
    routeLeaveHook = (nextLocation) => {
    };

    componentWillMount () {
        // window.myTemp = 1;
    };

    componentDidMount () {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    handleOk = () => {
        this.setState({ visible: false });
    };
    handleCancel = () => {
        this.setState({ visible: false });
    };


    render() {
        var self = this;
        const {opts, key, total, searchObj, selectedRowKeys, selectedRowKeysOutside, visible, alreadyRows, alreadyTotal, alreadySearchObj} = this.state;
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '序号',
                    dataIndex: 'id'
                },
                {
                    title: '产品线',
                    dataIndex: 'code'
                },
                {
                    title: '物料编码',
                    dataIndex: 'name'
                },

                {
                    title: '物料描述',
                    dataIndex: 'productDescription'
                },
                {
                    title: '库存属性',
                    dataIndex: 'productType'
                },
                {
                    title: '牌价',
                    dataIndex: 'packageNum'
                },
                {
                    title: '下浮价',
                    dataIndex: 'name1'
                },
                {
                    title: '下浮率',
                    dataIndex: 'currentNum'
                },
                {
                    title: '单位',
                    dataIndex: 'originalPrice'
                },
                {
                    title: '参考可用量',
                    dataIndex: 'currentPrice'
                },
                {
                    title: '开单数量',
                    dataIndex: 'currentPrice1'
                },
                {
                    title: '装箱数',
                    dataIndex: 'proMiddleType'
                },
                {
                    title: '最小起订量',
                    dataIndex: 'viewCount'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },

            ],
            rows: this.state.submitRows,
            rowSelection:{selectedRowKeys:selectedRowKeysOutside, onChange: self.onOutsideSelectChange}
        };
        const alreadyProps = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: alreadyTotal,
                current: alreadySearchObj.p,//当前页码
                pageSize: alreadySearchObj.s,//当前分页数
                onChange: this.alreadyPageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code'
                },
                {
                    title: '物料名称',
                    dataIndex: 'name'
                },
                {
                    title: '牌价',
                    dataIndex: 'showPrice'
                },

                {
                    title: '开单数量',
                    dataIndex: 'viewCount'
                },
                {
                    title: '提货地点',
                    dataIndex: 'name_3'
                },
                {
                    title: '分批发运',
                    dataIndex: 'name_4'
                },

            ],
            rows: alreadyRows,
            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                type: 'radio'
            }
        };


        return <div>
			<DmsTab options={opts} defaultKey={key} >
				<Button type="primary" style={{marginLeft: 10}}>提交</Button>
				<Button onClick={this.goBack}>取消</Button>
			</DmsTab>
			<div className="dms-table-box">
				<Row>
                    <Col span={6}>
                        <label>订单单号：</label>
                        <span>2016053100001</span>
                    </Col>
                    <Col span={6}>
                        <label>客户名称：</label>
                        <span>浙江电工</span>
                    </Col>
                    <Col span={6}>
                        <label>订单日期：</label>
                        <span>2016-05-31 15:30:45</span>
                    </Col>
                    <Col span={6}>
                        <label>订单整体折扣：</label>
                        <span>51%</span>
                    </Col>
                </Row>
                <Row style={{marginTop: 10}}>
                    <Col span={6}>
                        <label>订单状态：</label>
                        <span>已提交</span>
                    </Col>
                    <Col span={6}>
                        <label>提交人：</label>
                        <span>xxx</span>
                    </Col>
                    <Col span={6}>
                        <label className="ant-form-item-required">联系电话：</label>
                        <Input defaultValue="" style={{width: 130}}/>
                    </Col>
                    <Col span={6}>
                        <label className="ant-form-item-required">联系人：</label>
                        <Input defaultValue="" style={{width: 130}}/>
                    </Col>
                </Row>
                <Row style={{marginTop: 10}}>
                    <Col span={6}>
                        <label className="ant-form-item-required">实际收货地址：</label>
                        <Input defaultValue="" style={{width: 130}}/>
                    </Col>
                    <Col span={6}>
                        <label>备注：</label>
                        <Input defaultValue="" style={{width: 130}}/>
                    </Col>
                </Row>
			</div>
			<div>
				<DmsTab className="white-bg no-border" options={['订单商品']} defaultKey={0}/>
				<div className="dms-table-box">
					<div style={{marginBottom: 8}}>
						<Button onClick={this.searchHandler}>新增</Button>
						<Button style={{marginLeft: 10}}>删除</Button>
                        <Button style={{marginLeft: 10}}>下载模板</Button>
                        <Button style={{marginLeft: 10}}>导入</Button>
					</div>
					<TableView {...tableViewProps}/>
					<div className="order_amount" style={{marginTop: 20}}>
                        <p><span className="right">商品总金额：￥516,541</span></p>
                        <p><span className="right">优惠金额：￥516,541</span></p>
                        <p><span className="right">实际总金额：￥516,541</span></p>
                    </div>
				</div>

			</div>

			<Modal
				visible={visible}
				title="选择物料"
				onOk={this.handleOk}
				onCancel={this.handleCancel}
				maskClosable={false}
				width={1000}
				style={{top:20}}
				footer={null}
			>
				<div>
					<section className="section-bordered" style={{marginTop:0, paddingTop:5, paddingBottom:0}}>
						<Row>
                            <Col span={8}><label>物料名称：</label><Input style={{width:200}} value={this.state.name} onChange={this.nameChange}/></Col>
							<Col span={8}><label>物料编码：</label><Input style={{width:200}} value={this.state.code} onChange={this.codeChange}/></Col>
							<Col span={8}><Button onClick={this.getAlreadyArray}>搜索</Button></Col>
						</Row>
						<TableView {...alreadyProps} bordered style={{marginTop: 10}}/>
					</section>
					<Row type="flex" justify="center" style={{marginTop:15}}>
						<Col >
							<Button onClick={this.addSaveHandler}>确认</Button>
						</Col>
					</Row>
				</div>
			</Modal>


		</div>
    }
}
export default withRouter(SecondCusOrderAdd);



// WEBPACK FOOTER //
// ./src/routes/secCusOrder/add.js